import { Component, OnInit, EventEmitter, Output, Input, AfterViewInit, ElementRef, OnChanges, ViewChild, ViewContainerRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ISubscription } from 'rxjs/Subscription';

import { JobsiteEquipmentService } from '@fs/services/jobsite-equipment';
import { EquipmentModel, WarrantyModel, EquipmentWarrantyTypesFromCompany, EquipmentManufacturers, EquipmentCategories, DateValidity } from '@fs/models/equipment.model';
import { CustomerService } from '@fs/services/customer';
import { CommonService } from '@shared/services/common'
import { CommonMethods } from '@services/common.method';
import { TabOpenService } from '@services/tab-open.service';
import { NotificationsService } from '@shared/services/notification';
import { Constants } from '@shared/models/constants';
import { EquipmentFormMode } from '@fs/enums/common'
import { ActionName } from 'src/app/shared/enums/action-name';
import { PopupOptions } from "@fs/models/popup-options.model";
import { CodeTypeModel } from '@fs/models/code-type.model';
import { DatePipe } from '@angular/common';
import { SpinnerService } from 'src/app/shared/services/spinner.service';

@Component({
  selector: 'jobsite-equipment-detail-edit',
  templateUrl: './equipment-detail-edit.component.html',
  styleUrls: ['./equipment-detail-edit.component.scss'],
  providers: [JobsiteEquipmentService, DatePipe]
})
export class EquipmentDetailEditComponent implements OnInit, AfterViewInit {

  //#region Input/Output/ViewChild
  @Output() eventCloseEditModal = new EventEmitter();
  @Output() eventCloseEquipment = new EventEmitter();
  @Input() tabCounter: number;
  @Input() destroyTab: boolean;
  @Input() equipmentId: string = CommonMethods.GetID();
  @Input() duplicateEquipment: boolean = false;
  @Input() companyData: any;

  @Input() jobsiteId: string;
  @Input() customerId: string;
  //#endregion

  //#region Variable Declarations
  public equipmentEditForm: FormGroup;
  public dsEquipmentDetail: EquipmentModel;
  public dsWarranties: WarrantyModel[] = null;
  public dsEqManufacturer: EquipmentManufacturers[];
  public dsEqCategories: EquipmentCategories[];
  public ApproximateYearMask = "0000";
  public isUnsavedTriggered: boolean = false;
  public formType = "New";
  public selectedWarranties: WarrantyModel[];
  public minDate = Constants.DATETIME_MIN;
  public actionName = ActionName;
  public minimumAllowedDate: Date = new Date(1900, 0, 1);
  public popupOptions: PopupOptions = new PopupOptions();

  private FormMode: EquipmentFormMode = EquipmentFormMode.Add
  private subscriptions: ISubscription[] = [];
  private RequestType = Constants.RequestType_POST;
  public DateValidityCheck = DateValidity;
  //#endregion

  //#region Constructor
  constructor(private httpEquipmentService: JobsiteEquipmentService,
    public commonData: CommonService,
    private customerService: CustomerService,
    private _elementRef: ElementRef,
    public commonMethods: CommonMethods,
    private datePipe: DatePipe,
    private tabopen: TabOpenService,
    private toastr: NotificationsService,
    private showspinner: SpinnerService,
    private viewContainerRef: ViewContainerRef) {

  }
  //#endregion

  //#region Lifecycle Events
  ngOnInit() {
    this.CreateEquipmentForm();
    if (!CommonMethods.CheckNullOrUndefined(this.companyData, false)) {
      this.dsWarranties = Object.assign([], this.companyData.EquipmentWarrantyTypes);
      this.dsEqManufacturer = Object.assign([], this.companyData.EquipmentManufacturers);
      this.dsEqCategories = Object.assign([], this.companyData.EquipmentCategories);
    }

    if (!CommonMethods.CheckNullOrUndefined(this.equipmentId)) {
      if (!this.duplicateEquipment) {
        this.formType = "Edit";
        this.FormMode = EquipmentFormMode.Edit
      }
      else {
        this.formType = "New";
        this.FormMode = EquipmentFormMode.Duplicate

      }
      this.GetEquipmentDetail();
    }
  }

  ngAfterViewInit() {
    if (this.FormMode == EquipmentFormMode.Duplicate) {
      setTimeout(() => {
        $(this._elementRef.nativeElement).find(".serialNumber").focus();
      }, 200);
    }
    this.commonMethods.SetModalHeightWhenScrolled("#modal_container_" + this.tabCounter, $("#mainContainer")[0]);
  }

  ngOnChanges() {
    //#region Subscriptions
    let subscription = this.tabopen.ConfirmDestroyTabEvent.subscribe(
      response => {
        if (response.tabCounter == this.tabCounter) {
          this.SaveEquipmentDetail(true);
        }
      }
    );
    this.subscriptions.push(subscription);

    subscription = this.tabopen.destroyModalEvent.subscribe(response => {
      if (
        response.tabCounter == this.tabCounter &&
        response.event == "destroy"
      ) {
        this.equipmentEditForm.markAsPristine();
        this.tabopen.unsavedChangedDetected({
          dirty: false,
          Index: this.tabCounter
        });
        this.isUnsavedTriggered = false;
        if (this.FormMode != EquipmentFormMode.Duplicate) {
          this.eventCloseEquipment.emit({ FormMode: this.FormMode, Result: false });
        }
        else {
          this.eventCloseEditModal.emit({ FormMode: this.FormMode, Result: false });
        }
      } else if (
        response.tabCounter == this.tabCounter &&
        response.event == "save"
      ) {
        setTimeout(() => {
          this.SaveEquipmentDetail(false);
        }, 200);
      }
    });
    this.subscriptions.push(subscription);
    //#endregion
  }

  ngDoCheck() {
    if (!this.isUnsavedTriggered) {
      if (!CommonMethods.CheckNullOrUndefined(this.equipmentEditForm)) {
        let isDirty = this.equipmentEditForm.dirty;
        if (isDirty) {
          this.isUnsavedTriggered = true;
          this.tabopen.unsavedChangedDetected({
            dirty: isDirty,
            Index: this.tabCounter
          });
        }
      }
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(element => {
      element.unsubscribe();
    });
  }
  //#endregion

  //#region Equipment detail 
  public CloseEquipmentModal() {
    if (!CommonMethods.CheckNullOrUndefined(this.equipmentId))
      this.eventCloseEditModal.emit({ FormMode: this.FormMode, Result: this.equipmentEditForm.dirty, RefreshRequired: false });
    else
      this.eventCloseEquipment.emit({ FormMode: this.FormMode, Result: this.equipmentEditForm.dirty, RefreshRequired: false });
  }

  public Toggle__collapse(trg) {
    $(trg).toggleClass("hidden");
    var parent = $(trg);
    parent.find(".collapse__box__body").slideToggle();
  }
  public CheckValidDate() {
    if (!(this.equipmentEditForm.controls['InstallDate'].value instanceof Date))
      this.equipmentEditForm.controls['InstallDate'].patchValue(null);
  }
  public SaveEquipmentDetail(istabClosed: Boolean = false, instantSpinnerTime: number = Constants.defaultSpinnertimeout) {
    let isSaved = false;
    let isValid = this.equipmentEditForm.valid;
    if (isValid) {
      let formData = this.equipmentEditForm.value;
      let submitModel = new EquipmentModel();
      let ApproximateYear = CommonMethods.GetFullYear(formData.ApproximateYear);
      submitModel.ID = this.RequestType == Constants.RequestType_PUT ? formData.ID : CommonMethods.GetID();
      submitModel.Note = formData.Note;
      submitModel.ApproximateYear = ApproximateYear.length > 0 ? ApproximateYear : null;
      submitModel.Location = formData.Location;
      submitModel.InstallDate = (formData.InstallDate instanceof Date) ? this.commonMethods.GetFormattedDate(new Date(formData.InstallDate), null) : null;
      submitModel.Size = formData.Size;
      submitModel.SerialNumber = formData.SerialNumber;
      submitModel.IsActive = this.RequestType == Constants.RequestType_PUT ? formData.IsActive : true;
      submitModel.ModelNumber = formData.ModelNumber;
      submitModel.ManufacturerID = formData.Manufacturer;
      submitModel.CategoryID = formData.Category;
      submitModel.InstalledByID = formData.InstalledBy;
      submitModel.JobSiteID = this.jobsiteId;
      submitModel.ModifyDate = this.dsEquipmentDetail.ModifyDate;
      let warrantyModel: WarrantyModel[] = [];
      let self = this;
      this.selectedWarranties.forEach((value: WarrantyModel) => {
        let tempObject: WarrantyModel = new WarrantyModel();
        tempObject.ID = CommonMethods.CheckNullOrUndefined(value.ID) ? CommonMethods.GetID() : value.ID;
        tempObject.equipmentId = this.equipmentId;
        tempObject.WarrantyTypeID = value.WarrantyTypeID;
        tempObject.InstallDate = (CommonMethods.IsValidDate(value.InstallDate)) ? new Date(value.InstallDate).toDateString() : null;
        tempObject.ExpirationDate = value.ExpirationDate == undefined ? null : new Date(value.ExpirationDate).toDateString();

        tempObject.CreateDate = value.CreateDate;
        tempObject.ModifyDate = value.ModifyDate;
        tempObject.IsDirty = CommonMethods.CheckNullOrUndefined(value.IsDirty) ? false : value.IsDirty;
        if (!CommonMethods.IsValidDate(value.InstallDate) || !((new Date(value.InstallDate) >= this.minimumAllowedDate))) {
          if (isValid) {
            isValid = false;
          }
        }
        warrantyModel.push(tempObject);
      });
      submitModel.EquipmentWarranties = warrantyModel;
      if (isValid) {
        if (submitModel.ID != CommonMethods.GetID() && submitModel.ID != null && this.duplicateEquipment == false) {
          this.showspinner.showloader(this.viewContainerRef, this.tabCounter,instantSpinnerTime);
          this.httpEquipmentService.UpdateEquipment({ jobsiteId: this.jobsiteId, customerId: this.customerId, equipmentId: submitModel.ID }, submitModel).subscribe(
            response => {
              {
                if (this.FormMode != EquipmentFormMode.Duplicate) {
                  this.eventCloseEquipment.emit({ FormMode: this.FormMode, RefreshRequired: true });
                }
                else {
                  this.eventCloseEditModal.emit({ FormMode: this.FormMode, RefreshRequired: true });
                }
                isSaved = true;
                if (istabClosed) {
                  // complete tab closed
                  setTimeout(() => {
                    this.tabopen.DestroyTab(this.tabCounter);
                  }, 100);
                } else {
                  this.tabopen.unsavedChangedDetected({
                    dirty: false,
                    Index: this.tabCounter
                  });
                  this.isUnsavedTriggered = false;
                  this.toastr.success(Constants.CustomToastMessages().EquipmentUpdateSuccess, "Success");
                }
                this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
                return isSaved;
              }
            }, error => {
              this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
              this.toastr.error(error.error.Message, "Error");
            }
          )
        }
        else {
          this.showspinner.showloader(this.viewContainerRef, this.tabCounter,instantSpinnerTime);
          this.httpEquipmentService.CreateEquipment({ jobsiteId: this.jobsiteId, customerId: this.customerId }, submitModel).subscribe(
            response => {
              this.eventCloseEditModal.emit({ response, RefreshRequired: true });
              this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
              this.toastr.success(Constants.CustomToastMessages().EquipmentCreateSuccess, "Success");
            }, error => {
              this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
              this.toastr.error(error.error.Message, "Error");
            }
          )
        }
      }
    }
    else {
      this.commonMethods.markFormGroupTouched(this.equipmentEditForm)
      return false;
    }

    return true
  }

  private CreateEquipmentForm() {
    if (this.dsEquipmentDetail == undefined || this.dsEquipmentDetail.ID == undefined) {
      this.dsEquipmentDetail = new EquipmentModel();
      this.dsEquipmentDetail.InstalledByID = this.commonMethods.getCompany().CodeTypeData.InstalledBy.find(x => x.Code == "us").ID.toLowerCase();
      this.dsEquipmentDetail.InstalledBy.ID = this.dsEquipmentDetail.InstalledByID;
    }
    else if (this.duplicateEquipment) {
      this.dsEquipmentDetail.SerialNumber = "";
    }
    else {
      this.RequestType = Constants.RequestType_PUT;
    }
    let approximateYear = new Date();
    if (!CommonMethods.CheckNullOrUndefined(this.dsEquipmentDetail.ApproximateYear) && this.dsEquipmentDetail.ApproximateYear != "") {
      approximateYear = new Date(approximateYear.setFullYear(parseInt(this.dsEquipmentDetail.ApproximateYear)));
    }
    this.equipmentEditForm = new FormGroup({
      "ID": new FormControl(this.dsEquipmentDetail.ID),
      "Manufacturer": new FormControl(this.dsEquipmentDetail.EquipmentManufacturer.ID, Validators.required),
      "IsActive": new FormControl(this.dsEquipmentDetail.IsActive),
      "ModelNumber": new FormControl(this.dsEquipmentDetail.ModelNumber, [Validators.required, this.commonMethods.noWhitespaceValidator, Validators.maxLength(30)]),
      "Category": new FormControl(this.dsEquipmentDetail.EquipmentCategory.ID, Validators.required),
      "SerialNumber": new FormControl(this.dsEquipmentDetail.SerialNumber, [Validators.maxLength(30)]),
      "InstallDate": new FormControl(this.dsEquipmentDetail.InstallDate == null ? "" : new Date(this.dsEquipmentDetail.InstallDate)),
      "InstalledBy": new FormControl(this.dsEquipmentDetail.InstalledBy.ID, Validators.required),
      "Size": new FormControl(this.dsEquipmentDetail.Size, Validators.maxLength(20)),
      "Location": new FormControl(this.dsEquipmentDetail.Location, Validators.maxLength(40)),
      "ApproximateYear": new FormControl(this.dsEquipmentDetail.ApproximateYear == null ? "" : approximateYear),
      "Note": new FormControl(this.dsEquipmentDetail.Note, Validators.maxLength(1024))
    });
    this.selectedWarranties = this.dsEquipmentDetail.EquipmentWarranties;
    this.selectedWarranties.forEach(e => {
      if (this.FormMode == EquipmentFormMode.Duplicate) {
        e.ID = CommonMethods.GetID();
      }
      e.InstallDate = (CommonMethods.IsValidDate(e.InstallDate)) ? ((new Date(e.InstallDate) >= this.minimumAllowedDate)) ? new Date(e.InstallDate).toDateString() : null : null;
      e.IsValidInstallDate = (CommonMethods.IsValidDate(e.InstallDate)) ? ((new Date(e.InstallDate) >= this.minimumAllowedDate)) ? DateValidity.Valid : DateValidity.Valid_Before1900 : DateValidity.Invalid;
    });
  }

  private GetEquipmentDetail(instantSpinnerTime: number = Constants.defaultSpinnertimeout) {
    this.showspinner.showloader(this.viewContainerRef, this.tabCounter,instantSpinnerTime);
    this.httpEquipmentService.GetEquipmentDetail({ equipmentId: this.equipmentId, jobsiteId: this.jobsiteId, customerId: this.customerId, references: "*" }).subscribe(response => {
      this.dsEquipmentDetail = response;
      this.CreateEquipmentForm();
      this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
    }, error => {
      this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
    });
  }
  //#endregion

  //#region Warranty
  public warrantydataSelectionChange(_selectedWarrantyData: WarrantyModel) {
    let selectedWarrantyData: WarrantyModel = Object.create(_selectedWarrantyData);
    if (!CommonMethods.CheckNullOrUndefined(selectedWarrantyData)) {
      let installDate = this.equipmentEditForm.controls['InstallDate'].value;
      selectedWarrantyData.WarrantyTypeID = selectedWarrantyData.ID;
      selectedWarrantyData.WarrantyName = selectedWarrantyData.Name;
      let DurationType: CodeTypeModel[] = this.commonMethods.getCompany().CodeTypeData.DurationType;
      if (!CommonMethods.CheckNullOrUndefined(selectedWarrantyData.DurationTypeID)) {
        selectedWarrantyData.DurationType = DurationType.find(x => x.ID == selectedWarrantyData.DurationTypeID);
      }
      if (installDate != null && installDate.toString() != "") {
        selectedWarrantyData.ExpirationDate = selectedWarrantyData.LifetimeWarranty == true ? null : this.getExpirationDate(installDate, selectedWarrantyData.DurationType, selectedWarrantyData.DurationValue).toString();
      }
      selectedWarrantyData.IsDirty = true;
      selectedWarrantyData.InstallDate = installDate;
      if (CommonMethods.IsValidDate(installDate) && (new Date(installDate) >= this.minimumAllowedDate))
        selectedWarrantyData.IsValidInstallDate = DateValidity.Valid;
      else if (CommonMethods.IsValidDate(installDate))
        selectedWarrantyData.IsValidInstallDate = DateValidity.Valid_Before1900;
      else
        selectedWarrantyData.IsValidInstallDate = DateValidity.Invalid;
      this.selectedWarranties.push(selectedWarrantyData);
      this.equipmentEditForm.markAsDirty();
    }
  }

  public removeWarranty(item) {
    let index = this.selectedWarranties.indexOf(item)
    if (index != -1) {
      this.selectedWarranties.splice(index, 1);
      this.equipmentEditForm.markAsDirty();
    }
  }
  public InstallDateChanges(value, item) {
    item.IsDirty = true;
    item.InstallDate = value;
    let DurationType: CodeTypeModel[] = this.commonMethods.getCompany().CodeTypeData.DurationType;
    let warrantyDurationType: CodeTypeModel;
    if (this.FormMode == 0) {
      if (!CommonMethods.CheckNullOrUndefined(item.DurationTypeID) && !CommonMethods.CheckNullOrUndefined(DurationType)) {
        warrantyDurationType = DurationType.find(x => x.ID == item.DurationTypeID);
      }
    }
    else if (this.FormMode == EquipmentFormMode.Edit || this.FormMode == EquipmentFormMode.Duplicate) {
      warrantyDurationType = item.DurationType;
    }
    if (item.InstallDate != null && item.InstallDate.toString() != "") {
      item.ExpirationDate = item.LifetimeWarranty == true ? null : this.getExpirationDate(item.InstallDate, item.DurationType, item.DurationValue).toString();
    }
    if (CommonMethods.IsValidDate(item.InstallDate) && (new Date(item.InstallDate) >= this.minimumAllowedDate))
      item.IsValidInstallDate = DateValidity.Valid;
    else if (CommonMethods.IsValidDate(item.InstallDate))
      item.IsValidInstallDate = DateValidity.Valid_Before1900;
    else
      item.IsValidInstallDate = DateValidity.Invalid;
    this.equipmentEditForm.markAsDirty();
  }

  private getExpirationDate(installDate, WarrantyType, DurationValue) {
    if (CommonMethods.CheckNullOrUndefined(DurationValue) || CommonMethods.CheckNullOrUndefined(installDate) || CommonMethods.CheckNullOrUndefined(WarrantyType) || (new Date(installDate).toString()) == "Invalid Date") {
      return null;
    }
    else {
      let year = installDate.getFullYear();
      let ExpirationDate = new Date(installDate);

      if (WarrantyType.Code == "years") {
        ExpirationDate = new Date(year + DurationValue, installDate.getMonth(), installDate.getDate());
        ExpirationDate = this.commonMethods.addDaysInDates(ExpirationDate, -1)
      }
      else if (WarrantyType.Code == "days") {
        ExpirationDate = this.commonMethods.addDaysInDates(ExpirationDate, DurationValue - 1);
      }
      else if (WarrantyType.Code == "months") {
        ExpirationDate.setMonth(ExpirationDate.getMonth() + DurationValue);
        ExpirationDate = this.commonMethods.addDaysInDates(ExpirationDate, -1)
      }
      return ExpirationDate;
    }
  }
  //#endregion

}
